import { useState } from 'react';
import { useClassesTable } from '../../../../../components/Classes/hooks/useClassesTable';
import { ClassesModal } from '../../../../../components/Classes/Modals/ClassesModal';
import { InheritClassesModal } from '../../../../../components/Classes/Modals/InheritClassesModal';
import { TimetableClassesTable } from '../../../../../components/Classes/Tables/TimetableClassesTable';
import { useDeleteClasses } from '../../../../../hooks/useDeleteClasses';
import { usePermissionChecker } from '../../../../../hooks/usePermissionChecker';
import { showSuccessDeleteToast, showUserDbErrorToast } from '../../../../../utils/toast';

export const TimetableClassesContent = () => {
  const permissions = usePermissionChecker();

  const { deleteClass } = useDeleteClasses();

  const { data, DeleteDialog, confirmDelete } = useClassesTable();

  const [classesModalOpen, setClassesModalOpen] = useState<boolean>(false);
  const [inheritModalOpen, setInheritModalOpen] = useState<boolean>(false);
  const [classUuid, setClassUuid] = useState<null | string>(null);
  const [loading, setLoading] = useState<boolean>(false);

  function handleAdd() {
    setClassUuid(null);
    setClassesModalOpen(true);
  }

  function handleEdit(uuid: string) {
    setClassUuid(uuid);
    setClassesModalOpen(true);
  }

  async function handleDelete(uuids: string[]) {
    const confirmResult = await confirmDelete();
    if (!confirmResult) return;

    const classesToDelete = data.filter((c) => uuids.includes(c.uuid));

    if (!classesToDelete || classesToDelete.length === 0) {
      showUserDbErrorToast();
      return;
    }

    let deleteCount = 0;

    setLoading(true);

    for (const cl of classesToDelete) {
      const { error } = await deleteClass(cl.uuid);
      if (error) {
        showUserDbErrorToast();
        return;
      } else {
        deleteCount++;
      }
    }

    if (deleteCount === 1) {
      showSuccessDeleteToast([classesToDelete[0].name]);
    } else {
      showSuccessDeleteToast();
    }

    setLoading(false);
  }

  return (
    <>
      <TimetableClassesTable
        loading={loading}
        onAdd={() => handleAdd()}
        onEdit={(uuid) => handleEdit(uuid)}
        onInherit={() => setInheritModalOpen(true)}
        onDelete={(uuids) => handleDelete(uuids)}
        readonly={!permissions?.canWriteTimetable()}
      />

      <ClassesModal
        classUuid={classUuid}
        isOpen={classesModalOpen}
        onClose={() => {
          setClassUuid(null);
          setClassesModalOpen(false);
        }}
      />

      <InheritClassesModal isOpen={inheritModalOpen} onClose={() => setInheritModalOpen(false)} />

      <DeleteDialog />
    </>
  );
};
